import request from '@/utils/request';

export function getParkList() {
  return request({
    url: '/api/v1/resource/park/list',
    method: 'get',
    params: {}
  });
}

export function getParkRouteList(parkId) {
  return request({
    url: '/api/v1/resource/route/list',
    method: 'get',
    params: { parkId }
  });
}

export function getParkScenicList(parkId) {
  return request({
    url: '/api/v1/resource/map/list',
    method: 'get',
    params: { parkId }
  });
}

///panorama/address
export function getPanoramaAddress(params){
  return request({
    url: '/api/v1/resource/panorama/address',
    method: 'get',
    params: params
  });
}